import React, { useMemo } from "react"
import { Row, Col } from "reactstrap"
import { Link } from "react-router-dom"
import styled, { keyframes } from "styled-components"
import Markdown from "utils/Markdown"
import userPlaceHolderImage from "assets/images/user-placeholder.hbd.jpg"
import { useQuery } from "@apollo/react-hooks"
import gql from "graphql-tag"
import nl2br from "utils/nl2br"
import * as styles from "./index.module.hbd.scss"
import { Featured } from "./Featured"
import { Query } from "@apollo/react-components"
import { RandomRead } from "./RandomRead"
import { PERIOD, usePeriod } from "./usePeriod"
import useInterviewLink from "./useInterviewLink"
import mascotteImg from "assets/images/25hbd/2026/mascotte.png"
import okenkiImg from "assets/images/25hbd/2026/okenki.png"
import moonLiImg from "assets/images/25hbd/2026/moon-li.jpg"

const Home = ({ currentEdition }) => {
  const theme = useQuery(
    gql`
      query Theme {
        currentEdition {
          id
          theme
        }
      }
    `,
    { fetchPolicy: "cache-only" }
  ).data.currentEdition.theme
  const period = usePeriod(currentEdition)
  const interviewLink = useInterviewLink(currentEdition)
  const randomReadYear = period > PERIOD.DURING ? currentEdition.year : currentEdition.year - 1
  return pug`
    .home-page
      .d-md-flex(style={ margin: "-1.5rem", marginBottom: "calc(-1.5rem - 4px)", fontSize: "0.95rem" })
        .flex-grow-1
          .home-page-main-block
            h1.mb-4
              | 25 Heures de la BD et de l'Illustration
            .d-flex.flex-column.align-items-center.flex-sm-row.align-items-sm-start.flex-md-column.align-items-md-center.flex-lg-row.align-items-lg-start
              img.d-block.mb-4.mb-sm-0.mb-md-4.mb-lg-0.mr-sm-3.mr-md-0.mr-lg-3.mt-3(src=mascotteImg alt="" width=200)
              .flex-grow
                Markdown= INTRO_TEXT_MD
            div(style={ clear: 'left' })
            if period < PERIOD.DAY_BEFORE
              .lead.p-3.py-4.text-center.mt-4.mb-4
                p.mb-1 La douzième édition des 25HBD aura lieu les #[strong 24 et 25 octobre] 2025 de #[strong 13h00 à 13h00] (heure française).
                p.m-0(style={ fontSize: "0.9em" })
                  | Inscriptions #[Link(to="/register") ici →]
            if period === PERIOD.DAY_BEFORE
              p.lead.p-3.py-4.text-center.mt-4.mb-4
                | Le thème et la contrainte seront donnés ici à 13h !!
            if period >= PERIOD.DURING
              .lead.showtime.p-3.text-center
                Markdown= theme || "Thème à venir"
        aside.my-md-5.text-center.px-4.d-flex.flex-column.d-md-block.align-items-center.pb-5.pb-md-0(style={ gap: '20px' })
          Vip(src=moonLiImg links=[interviewLink("godparentInterview")], imgStyle={ width: "100%", maxWidth: 160 }) Moon Li, marraine 2026
          Vip(src=okenkiImg links=[interviewLink("illustratorInterview")], imgStyle={ width: "100%", maxWidth: 160 }) Okenki, illustrateur 2026
          //- TODO 2026 : partenaire et affiche de l'edition
          // Vip(src="" links=[{ label: "Interview à venir" }], imgStyle={ width: "100%", maxWidth: 160 }) Partenaire 2026
          // div
          //   a.d-inline-block.mt-4.mx-auto(href="", target="blank")
          //     img(src=afficheMiniImg, alt="Affiche", width=120)
          //   .mt-2(style={fontSize: "0.9em", lineHeight: "1.2em"})
          //     a(href="", target="blank") Télécharger l'affiche de la 12ème édition
      RandomRead(year=randomReadYear)
  `
}

const INTRO_TEXT_MD = `
Les 25 Heures de la BD et de l'Illustration sont un marathon artistique qui se déroule en ligne.

Il faut créer une bande dessinée de 12 pages ou une série de 12 illustrations ou un webtoon de 24 panels, avec un thème et une contrainte imposés, dans un délai de 25 heures.

Tout le monde peut participer, quel que soit son niveau ou son âge.

Pas de jury, mais un compteur. Les plus rapides décrochent une tortue d'or, les retardataires une tortue d'argent et les frimeuses une tortue rouge.

Pour plus de détails sur le déroulement de l'événement, consulte le règlement.
`

function Vip({ src, to, href, children, links, placeholder, imgStyle, className, style }) {
  return pug`
    .vip(className=className, style=style)
      AnyLink(to=to)
        .vip-thumbnail
          img(src=(src || userPlaceHolderImage) alt=children style=imgStyle)
      .mt-2
        div
          AnyLink.link-unstyled(to=to href=href)
            span.vip-name= children
        .vip-links
          each link, index in links.filter(Boolean)
            AnyLink(key=index to=link.to href=link.href target=link.target)= link.label
  `
}

function AnyLink(props) {
  let ComponentToUse = "span"
  if (typeof props.href === "string") {
    ComponentToUse = "a"
  }
  if (typeof props.to === "string") {
    ComponentToUse = Link
  }
  return <ComponentToUse {...props} />
}

export default Home
